import React, { useEffect, useRef, useState } from 'react';
import { cartClass } from '@/react/data';
import { useCartContext } from '@/react/store/context';
import { changeCartItem, rewriteCart } from '@/react/store/reducer';
const CalcCartRow = ({ item, index, isMontage }) => {
    const [{ cart }, dispatch] = useCartContext();
    function deleteCartItem() {
        const msg = `Вы уверены, что хотите удалить элемент "${item.description}" из списка товаров?`;
        if (!confirm(msg))
            return;
        if (isMontage) {
            $('#calcZV__autowork input[type="checkbox"]').removeAttr('checked');
            localStorage.removeItem('_dm_calc_montage');
        }
        dispatch(rewriteCart(cart.filter((_, i) => i !== index)));
    }
    function changeItemQty(value) {
        if (isMontage)
            return;
        if (value < 1 || value > 999)
            return;
        dispatch(changeCartItem({ index, key: 'count', value }));
    }
    const [isEdit, setEdit] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        if (!isEdit || !ref.current)
            return;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
    }, [isEdit]);
    const btnStyle = {
        height: '31px', width: '31px', display: 'inline-flex', padding: '0',
        justifyContent: 'center', alignItems: 'center', margin: '0', lineHeight: '1',
    };
    function onChangeQty(value) {
        changeItemQty(value < 1 ? 1 : value);
        setEdit(false);
    }
    function isNotValidNumber(value, min = 1) {
        return (+value < min && value !== '') || value === '-';
    }
    function getSquare() {
        return !isNaN(+item.square) && item.type !== 'montage'
            ? (+item.square * item.count).toFixed(3)
            : item.square;
    }
    return (React.createElement("tr", { className: `${cartClass}__row` },
        React.createElement("td", null, index + 1),
        React.createElement("td", null, item.description),
        React.createElement("td", null, getSquare()),
        React.createElement("td", null, item.price),
        React.createElement("td", null, !isEdit
            ? (React.createElement("div", { className: `${cartClass}__item__qty`, style: { display: 'inline-flex', alignItems: 'center' } },
                React.createElement("input", { type: "button", value: item.count > 1 && !isMontage ? '-' : '✕', style: btnStyle, title: item.count > 1 && !isMontage ? 'Убавить количество' : 'Удалить элемент корзины', onClick: () => {
                        if (item.count > 1 && !isMontage)
                            changeItemQty(item.count - 1);
                        else
                            deleteCartItem();
                    } }),
                React.createElement("span", { style: { width: 'auto' }, onClick: () => setEdit(true) }, item.count),
                React.createElement("input", { type: "button", value: "+", style: btnStyle, title: "\u041F\u0440\u0438\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E", onClick: () => changeItemQty(item.count + 1) })))
            : (React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                React.createElement("input", { type: "number", defaultValue: item.count, max: 999, style: { height: '31px', padding: '5px', width: '92px' }, placeholder: "0", ref: ref, onBlur: ({ target }) => onChangeQty(+target.value), onChange: ({ target }) => {
                        if (isNotValidNumber(target.value))
                            target.value = '1';
                    }, onKeyUp: (e) => {
                        const { key, currentTarget } = e;
                        if (key !== 'Enter')
                            return;
                        onChangeQty(+currentTarget.value);
                    } })))),
        React.createElement("td", null, item.type !== 'montage'
            ? (+item.price * item.count).toFixed(2) : ((item === null || item === void 0 ? void 0 : item.totalPrice) || 0))));
};
export default CalcCartRow;
